import styled from "styled-components";

export const Banner = styled.div`
  border-radius: 8px;
  box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.17);
  background-color: var(--global-light-gray);
  margin: var(--global-spacing-l);
  color: var(--global-dark-gray);
  text-align: center;
  padding: var(--global-spacing-m);
`;

export const DarkBanner = styled(Banner)`
  background: linear-gradient(0deg, #29343d, #29343d), #f2f8ff;
  color: var(--global-light-gray);
`;
